import "./theme-change.style.scss";

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { createStructuredSelector } from "reselect";

import { setThemeSetting } from "../../redux/theme/theme.action";
import { selectThemeSetting } from "../../redux/theme/theme.selector";

function ThemeChange(props) {
	const { setThemeSetting, theme } = props;
	const [isActive, setActive] = useState("false");

	const location = useLocation();

	useEffect(() => {
		const cssPath = document.getElementsByClassName("theme-change-wrapper")[0];
		const hiddenPaths = ["/business-insights"];

		if (hiddenPaths.includes(location.pathname)) {
			cssPath.style.display = "none";
		} else {
			cssPath.style.display = "flex";
		}
	}, [location.pathname]);

	useEffect(() => {
		document.body.classList.remove(theme.theme_color === "light-theme" ? "dark-theme" : "light-theme");
		document.body.classList.add(theme.theme_color);
	}, [theme.theme_color]);

	const handleToggle = () => {
		setActive(!isActive);
	};

	return (
		<div
			// className=" "
			className={`theme-change-wrapper ${isActive ? "" : "active"}`}
		>
			<div className='theme-click-icon'>
				<a href='#!' onClick={handleToggle}>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						version='1.1'
						width='512'
						height='512'
						x='0'
						y='0'
						viewBox='0 0 511.99934 511'
						className=''
					>
						<g>
							<path
								xmlns='http://www.w3.org/2000/svg'
								d='m497.917969 201.585938c7.378906-7.382813 5.71875-20.039063-3.753907-24.992188-13.214843-6.910156-20.59375-1.808594-31.304687-12.523438-12.699219-12.695312-3.328125-24.6875-20.300781-41.660156-16.804688-16.804687-29.085938-7.722656-41.65625-20.296875-12.703125-12.703125-3.324219-24.683593-20.300782-41.660156-16.804687-16.804687-29.082031-7.722656-41.65625-20.296875-10.675781-10.671875-5.640624-18.144531-12.515624-31.296875-4.953126-9.472656-17.613282-11.132813-24.992188-3.753906-89.28125 89.277343-71.066406 71.066406-86.429688 86.425781-2.558593-.128906-5.109374.78125-7.03125 2.703125-65.433593 65.433594-11.121093 11.125-98.90625 98.90625-15.609374 15.597656-15.613281 40.867187 0 56.46875l33.722657 33.734375c3.785156 3.777344 3.523437 10.015625-.652344 13.449219l-81.828125 67.246093c-3.199219 2.632813-3.664062 7.355469-1.03125 10.558594 2.636719 3.207032 7.367188 3.652344 10.554688 1.03125l81.828124-67.25c10.988282-9.027344 11.796876-25.597656 1.734376-35.644531l-33.722657-33.734375c-9.746093-9.734375-9.75-25.503906 0-35.25l53.378907-53.375 143.421874 143.417969c2.929688 2.925781 7.675782 2.929687 10.605469 0 2.929688-2.929688 2.929688-7.675781 0-10.605469l-143.421875-143.421875 30.875-30.875c160.453125 160.453125 21.171875 21.171875 179.59375 179.597656l-30.871094 30.875-11.425781-11.429687c-2.929687-2.925782-7.679687-2.925782-10.609375 0-2.925781 2.929687-2.925781 7.679687 0 10.609375l11.429688 11.425781-53.375 53.371094c-9.742188 9.746094-25.515625 9.753906-35.261719 0l-33.730469-33.71875c-10.050781-10.046875-26.621094-9.253906-35.644531 1.742187l-98.578125 119.957031c-27.679688 33.664063-83.160156 12.960938-81-31.261718 1.117188-22.953125 16.171875-32.710938 27.734375-42.210938 3.199219-2.628906 3.660156-7.351562 1.03125-10.554687-2.628906-3.199219-7.355469-3.664063-10.554687-1.035157-11.902344 9.78125-31.726563 23.035157-33.1914068 53.070313-2.8476562 58.316406 70.6328128 86.4375 107.5664068 41.515625l98.582031-119.960938c3.441406-4.191406 9.679687-4.421874 13.453125-.652343l33.726562 33.714843c15.597656 15.613282 40.863282 15.613282 56.476563.003907 45.441406-45.441407-77.71875 77.726562 98.898437-98.898438 1.816406-1.816406 2.839844-4.3125 2.707032-7.039062 17.203124-17.203125 59.789062-59.789063 86.425781-86.425781zm-131.207031 38.269531 16.8125-16.8125c2.929687-2.929688 2.929687-7.679688 0-10.609375-2.929688-2.925782-7.675782-2.925782-10.605469 0l-16.8125 16.816406-35.863281-35.863281 16.8125-16.8125c2.929687-2.929688 2.929687-7.675781 0-10.605469-2.929688-2.929688-7.675782-2.929688-10.605469 0l-16.8125 16.8125-35.859375-35.859375 16.8125-16.816406c2.929687-2.929688 2.929687-7.675781 0-10.605469-2.929688-2.925781-7.679688-2.925781-10.609375 0l-16.8125 16.8125-35.859375-35.859375 37.679687-37.683594c2.078125 8.980469 4.574219 19.144531 16.542969 31.113281 4.226562 4.226563 8.449219 7.507813 12.90625 10.03125 3.597656 2.039063 8.175781.78125 10.222656-2.828124 2.039063-3.605469.773438-8.183594-2.832031-10.222657-3.265625-1.847656-6.433594-4.332031-9.691406-7.585937-12.179688-12.183594-11.023438-20.734375-14.847657-32.808594 36.199219-36.195312 35.246094-35.820312 35.851563-34.65625 4.890625 9.355469 1.042969 20.796875 15.199219 34.953125 16.808594 16.804687 29.082031 7.71875 41.660156 20.292969 12.675781 12.675781 3.347656 24.714844 20.296875 41.660156 16.804687 16.804688 29.082031 7.722656 41.660156 20.296875 12.675781 12.679687 3.347657 24.714844 20.296875 41.664063 14.160156 14.160156 25.648438 10.335937 34.960938 15.207031 1.132812.585937 2.996094-1.808594-37.636719 38.824219-2.078125-8.980469-4.570313-19.144532-16.542969-31.117188-22.921875-22.921875-36.816406-10.238281-55.828125-29.25-18.785156-18.78125-6.515625-33.089844-29.242187-55.828125-4.25-4.253906-8.476563-7.539063-12.925782-10.046875-3.605468-2.039062-8.183593-.765625-10.21875 2.84375-2.035156 3.605469-.761718 8.183594 2.847657 10.21875 3.246093 1.832031 6.417969 4.316406 9.691406 7.589844 19.054687 19.0625 6.226563 32.816406 29.238281 55.828125 22.726563 22.726562 37.039063 10.464843 55.832032 29.25 12.179687 12.183593 11.023437 20.734375 14.847656 32.816406l-34.703125 34.703125zm0 0'
								fill='#000'
								data-original='#000000'
								className=''
							/>
							<path
								xmlns='http://www.w3.org/2000/svg'
								d='m364.339844 289.570312c2.929687-2.929687 2.929687-7.675781 0-10.605468l-140.28125-140.28125c-2.929688-2.929688-7.679688-2.929688-10.605469 0-2.929687 2.929687-2.929687 7.675781 0 10.605468l140.28125 140.28125c2.929687 2.929688 7.675781 2.929688 10.605469 0zm0 0'
								fill='#000'
								data-original='#000000'
								className=''
							/>
							<path
								xmlns='http://www.w3.org/2000/svg'
								d='m32.15625 443.96875c0 14.933594 12.089844 26.882812 26.894531 26.882812 6.886719 0 13.777344-2.621093 19.019531-7.863281 10.511719-10.511719 10.511719-27.523437 0-38.035156-10.511718-10.511719-27.523437-10.511719-38.035156 0-5.082031 5.078125-7.878906 11.832031-7.878906 19.015625zm18.484375-8.410156c4.648437-4.648438 12.171875-4.652344 16.824219 0 4.648437 4.648437 4.648437 12.171875 0 16.824218-4.640625 4.636719-12.1875 4.636719-16.824219 0-4.648437-4.652343-4.652344-12.175781 0-16.824218zm0 0'
								fill='#000'
								data-original='#000000'
								className=''
							/>
							<path
								xmlns='http://www.w3.org/2000/svg'
								d='m501.167969 264.589844c-7.914063-13.589844-15.335938-20.480469-22.066407-20.480469-6.730468 0-14.15625 6.890625-22.066406 20.480469-2.542968 4.363281-10.832031 19.5-10.832031 31.046875 0 18.140625 14.757813 32.898437 32.898437 32.898437 18.140626 0 32.898438-14.757812 32.898438-32.898437 0-11.546875-8.292969-26.683594-10.832031-31.046875zm-22.066407 48.945312c-9.871093 0-17.898437-8.027344-17.898437-17.898437 0-9.851563 11.855469-30.796875 17.898437-35.867188 6.042969 5.070313 17.898438 26.015625 17.898438 35.867188 0 9.871093-8.03125 17.898437-17.898438 17.898437zm0 0'
								fill='#000'
								data-original='#000000'
								className=''
							/>
						</g>
					</svg>
				</a>
			</div>
			<ul>
				<li>
					<a
						href='#!'
						onClick={() => {
							setThemeSetting({ theme_color: "light-theme" });
							document.body.classList.remove("esrp-theme", "dark-theme");
							handleToggle();
						}}
						id='light-theme'
						className='light theme-color'
					>
						<span className='color light' />
						<label>Light</label>
					</a>
				</li>
				<li>
					<a
						href='#!'
						onClick={() => {
							setThemeSetting({ theme_color: "dark-theme" });
							document.body.classList.remove("light-theme", "esrp-theme");
							handleToggle();
						}}
						id='dark-theme'
						className='dark theme-color'
					>
						<span className='color dark' />
						<label>Dark</label>
					</a>
				</li>
			</ul>
		</div>
	);
}

const mapStateToProps = createStructuredSelector({
	theme: selectThemeSetting,
});

const mapDispatchToProps = (dispatch) => ({
	setThemeSetting: (theme) => dispatch(setThemeSetting(theme)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemeChange);
